import { render, staticRenderFns } from "./KirchhoffLawsViz.vue?vue&type=template&id=19f58a42&scoped=true"
import script from "./KirchhoffLawsViz.vue?vue&type=script&lang=js"
export * from "./KirchhoffLawsViz.vue?vue&type=script&lang=js"
import style0 from "./KirchhoffLawsViz.vue?vue&type=style&index=0&id=19f58a42&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f58a42",
  null
  
)

export default component.exports